import Axios from 'axios'

const biDemographicProfile = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BASE_URL_API + '/dashboard/bi/v1'
    return AxiosInstance
  },

  getPerfilExames(period, exame) {
    return this.axios().get('/perfil-exames', {
      params: { periodo: period, ...(exame ? { exame } : {}) },
    })
  },

  getTopExamesPerfil(period, genero, faixaEtaria) {
    return this.axios().get('/perfil-exames/top-exames-perfil', {
      params: {
        periodo: period,
        ...(genero ? { genero } : {}),
        ...(faixaEtaria ? { faixaEtaria } : {}),
      },
    })
  },

  getDistribuicaoEtaria(period, exame) {
    return this.axios().get('/perfil-exames/distribuicao-etaria', {
      params: { periodo: period, ...(exame ? { exame } : {}) },
    })
  },

  getDemandaSazonal(period, especialidadeCodigo) {
    return this.axios().get('/perfil-exames/demanda-sazonal', {
      params: {
        periodo: period,
        ...(especialidadeCodigo ? { especialidadeCodigo } : {}),
      },
    })
  },
}

export default biDemographicProfile
